var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 7.99968L4 11.9997C4 12.3533 4.14048 12.6924 4.39052 12.9425C4.64057 13.1925 4.97971 13.333 5.33333 13.333L12 13.333C12.3536 13.333 12.6928 13.1925 12.9428 12.9425C13.1929 12.6924 13.3333 12.3533 13.3333 11.9997L13.3333 5.33301C13.3333 4.97939 13.1929 4.64025 12.9428 4.3902C12.6928 4.14015 12.3536 3.99968 12 3.99968L8 3.99968",
    stroke: "#2121BF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66797 8.66699L2.66797 2.66699",
    stroke: "#2121BF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66797 6L2.66797 2.66667L6.0013 2.66667",
    stroke: "#2121BF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.fc12fa0a8bc4b5bcbcd37bd97eaad618.svg";
export { ForwardRef as ReactComponent };